<div class="row">
  <div class="twelve columns">
    <h2 class="fieldset-title" style="font-size: x-large;">Territory Budgets</h2>
  </div>
</div>
<div class="row">
  <div class="twelve columns">
    <div class="two columns">
      <button soho-button="secondary" icon="refresh" (click)="GetTerritoryBudgets()">Refresh</button>
    </div>
    <div class="two columns">
      <button soho-button="primary" icon="delete-grid-row" (click)="DeleteBudgets()" soho-tooltip
        title="Delete selected territory budgets."><span>Delete</span></button>
    </div>
  </div>
</div>
<div class="row top-padding" soho-busyindicator [blockUI]="true" [text]="Message">
  <div class="twelve columns demo" role="main">
    <div soho-datagrid [columns]="grid_Columns" id="Requestdatagrid" [data]="data" [selectable]="'multiple'"
      [paging]="true" [pagesize]="10" filterable="true" [clickToSelect]="false"></div>
  </div>
</div>